import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { AdminCustomer } from '@/types/customer';

type CustomerType = Pick<
  AdminCustomer,
  'id' | 'fullName' | 'email' | 'phoneNumber' | 'avatar' | 'isActive' | 'isEmailConfirmed'
>;

export type CustomerState = {
  dataCustomer: CustomerType[];
};

export const customerInitialState: CustomerState = {
  dataCustomer: [],
};

export const slice = createSlice({
  name: 'customer',
  initialState: customerInitialState,
  reducers: {
    setListCustomerAction(
      state,
      {
        payload,
      }: PayloadAction<{
        data: CustomerType[];
      }>,
    ) {
      state.dataCustomer = payload.data;
    },
  },
});

export const { setListCustomerAction } = slice.actions;

export default slice.reducer;
